/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";

//import redux
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  beneCategories,
  setToggle,
  resetToggle,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";

//import components
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ListContainer from "../../../../components/_utils/CommonListView/ListContainer/index.jsx";
import ListTextWithIcon from "../../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper/index.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TickerAnimation from "../../../../components/_utils/TickerAnimation/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import accountNameStandardised from "../../../../utils/accountNamestandardised.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import {
  ReimburseViewAll,
  removeNewLabel,
  addNewLabel,
} from "../../../../redux/features/accounts/ReimburseAccount/index.js";

const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const ReimbursementAccountViewAll = ({
  id,
  remPan,
  type,
  remAccount,
  flow,
  setOpenBeneAssociate,
  remIFSC,
  setModalOpen,
  setTxnPayLoad,
  onAccountSelect,
  popupType,
  openBeneAssociate,
  mainType,
  accActiveInactiveState,
  activeInactivePan,
  activeInactiveFlow,
  activeInactiveIfsc,
  activeInactiveBank,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { services } = useSelector((state) => state.refreshToken);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { storedPage, toggle } = useSelector(
    (state) => state.beneAllVerification,
  );
  const dispatch = useDispatch();
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  // useref
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const approvalStatusSyncedToUrlRef = useRef(false);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const lastElementRef = useRef();

  //usestate
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });
  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [Labeldata, setLabeldata] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? []
      : searchParam.get("label")?.split(",").filter(Boolean) || [],
  );

  const [showSearchBar, setShowSearchBar] = useState(false);

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? 1
      : Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : location?.state?.approvalStatus === "approved"
        ? "approved"
        : location?.state?.approvalStatus === "pending"
          ? "pending"
          : searchParam.get("status") || "",
  );

  const [currentCategory, setCurrentCategory] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : searchParam.get("category") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : searchParam.get("search") || "",
  );

  const [startDateFilter, setStartDateFilter] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : dateFromUrl.start,
  );
  const [endDateFilter, setEndDateFilter] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? ""
      : dateFromUrl.end,
  );
  const [accountNumber, setAccountNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveBank
      : type === "ReimbursementAcc" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : searchParam.get("accountNo") || "",
  );

  const [isIfsc, setIsIfsc] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveIfsc
      : type === "ReimbursementAcc" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : searchParam.get("ifsc") || "",
  );
  const [panNumber, setPanNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Pan" || activeInactiveFlow === "Existing")
      ? activeInactivePan
      : type === "ReimbursementAcc" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : searchParam.get("pan") || "",
  );

  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const [selectedValue, setSelectedValue] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? PaginationConfiguration.paginationSmall
      : searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const [pageSize, setPageSize] = useState(
    type === "ReimbursementAcc" || type === "activeInactive"
      ? PaginationConfiguration.paginationSmall
      : searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [animateViewAll, setAnimateViewAll] = useState(false); // State defined for managing the initial animation of grid view
  const [inputData, setInputData] = useState([]);

  const handleSubmit = (key, value) => {
    if (type !== "ReimbursementAcc" && type !== "activeInactive") {
      handleSearchParams(key, value);
    }
  };

  const handleSelectAll = () => {
    const filteredItems = filteredData.filter(
      (item) => item?.approval_status !== "archived",
    );

    const allIds = filteredItems?.map((item) => item.id);
    setLabelAccounts((prev) => {
      const isPageFullySelected = allIds.every((id) => prev.includes(id));

      if (isPageFullySelected) {
        return [];
      } else {
        return [...allIds];
      }
    });
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      fetchData();
      labelActionDispatchedRef.current = false;
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };

  const handleDataPopup = (data) => {
    onAccountSelect(
      data?.bank_name,
      data?.bank_acc_no,
      data?.ifsc_code,
      data?.id,
      data?.category,
      data?.pan_no,
      data?.labels,
    );
    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountIFSC: data.ifsc_code,
      bankAccountName: data.bank_account_holder_full_name,
      bankAccountNo: data.bank_acc_no,
      bankLogo: data.bank_name,
      beneAccountId: data.id,
      pan: data.pan_no,
      labels: data.labels,
      // settleType: data.settle_type,
    }));
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      const startTs = convertDate(start);
      const endTs = convertDate(end);
      setStartDateFilter(startTs);
      setEndDateFilter(endTs);
      if (type !== "ReimbursementAcc" && type !== "activeInactive") {
        handleSearchParams("date", `${startTs},${endTs}`);
      }
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      if (type !== "ReimbursementAcc" && type !== "activeInactive") {
        handleSearchParams("date", "");
      }
    }
  };

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }

    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget?.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });
    }
    dispatch(setToggle(newToggleValue));
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(storedPage) || currentPage;
    setCurrentPage(nextPage);
    if (type !== "ReimbursementAcc" && type !== "activeInactive") {
      handleSearchParams("pagesize", value);
      handleSearchParams("pageno", nextPage);
    }
    toggleDropdown();
  };

  const filteredData = accumulatedData;

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
    if (isLabelClicked) {
      setLabelAccounts([]);
    }
    if (type !== "ReimbursementAcc" && type !== "activeInactive") {
      handleSearchParams("pageno", page);
    }
  };

  const handleClearFilters = () => {
    setAnimateViewAll(false);
    const defaultPage = GlobalConfiguration?.lengthCheckOne;
    const defaultSize = dropdownOptionsList[0];
    setCurrentCategory("");
    setStartDateFilter("");
    setEndDateFilter("");
    setCurrentCategory("");
    setAccountNumber("");
    setShowSearchBar(false);
    setSearchUserText("");
    setIsIfsc("");
    setLabelSearchText([]);
    setisLabelClicked(false);
    setCurrentStatus("");
    setCurrentPage(defaultPage);
    setSearchUserTextDebounce("");
    setPanNumber("");

    if (type !== "ReimbursementAcc" && type !== "activeInactive") {
      navigate(
        {
          pathname: location.pathname,
          search: `?pageno=${defaultPage}&pagesize=${defaultSize}`,
        },
        { replace: true },
      );
    }
    if (type === "activeInactive" && activeInactiveFlow === "Pan") {
      setPanNumber(activeInactivePan);
    } else if (type === "activeInactive" && activeInactiveFlow === "Bank") {
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (activeInactiveFlow === "Existing") {
      setPanNumber(activeInactivePan);
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    const res = await dispatch(
      addNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToAssign,
      }),
    );

    if (addNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    setLoading(false);
    if (addNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      removeNewLabel({
        record_ids: toArray(LabelAccounts),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (
      type === "ReimbursementAcc" ||
      approvalStatusSyncedToUrlRef.current ||
      type === "activeInactive"
    ) {
      return;
    }
    const statusFromState = location?.state?.approvalStatus;
    if (statusFromState === "approved" || statusFromState === "pending") {
      handleSearchParams("status", statusFromState);
      approvalStatusSyncedToUrlRef.current = true;
    }
  }, [location?.state?.approvalStatus, type, handleSearchParams]);

  const fetchData2 = async () => {
    let response;
    let data = [];
    setLoadingData(true);
    setAnimateViewAll(false);

    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  async function fetchData() {
    setLoading(true);
    setAnimateViewAll(false);
    try {
      if (currentPage === GlobalConfiguration.lengthCheckOne) {
        setLoading(true);
      }

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        ...(type === "activeInactive" && {
          associate:
            type === "activeInactive" && accActiveInactiveState === "active"
              ? ["pending", "approved"]
              : type === "activeInactive" &&
                  accActiveInactiveState === "inactive"
                ? ["blocked", "archived", "rejected"]
                : undefined,
        }),
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status = currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.categoryName = currentCategory;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          !!startDateFilter &&
          !!endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date = startDateFilter;
          queryParams.end_date = endDateFilter;
        }

        if (accountNumber !== "" || remAccount) {
          queryParams.bank_account_no = remAccount ? remAccount : accountNumber;
        }

        if (isIfsc !== "" || remIFSC) {
          queryParams.ifsc = remIFSC
            ? remIFSC.toUpperCase()
            : isIfsc.toUpperCase();
        }

        if (panNumber !== "" || remPan) {
          queryParams.pan = remPan
            ? remPan.toUpperCase()
            : panNumber.toUpperCase();
        }

        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (!!LabelSearchText?.length) {
          queryParams.labels = LabelSearchText;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(ReimburseViewAll(queryParams));
      const newData = response?.payload?.reimbursement_accounts || [];
      setMainData(response?.payload);
      setAccumulatedData(newData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  const onMount = () => {};

  useEffect(() => {
    dispatch(enableSwitcher());

    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    scrollContainerRef?.current?.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }, [toggle, currentPage, accumulatedData]);

  useEffect(() => {
    setLoading(true);
    fetchData().finally((x) => setLoading(false));
    let availableLabels = sessionStorage?.getItem("ReimburseAvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    markerData,
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    LabelSearchText,
    remAccount,
    remIFSC,
    remPan,
    isIfsc,
    panNumber,
    accActiveInactiveState,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
    currentStatus,
  ]);
  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus),
    );
  };

  useEffect(() => {
    if (type === "ReimbursementAcc" || type === "activeInactive") {
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
    if (type === "activeInactive") {
      dispatch(resetToggle());
    }
  }, []);

  return (
    <>
      <div
        className={`bg-primary-bg ${type === "ReimbursementAcc" || type === "activeInactive" ? "h-full" : "h-screen"}  flex flex-col relative overflow-hidden`}
        style={{
          width:
            type === "ReimbursementAcc" || type === "activeInactive"
              ? ""
              : "var(--full-width)",
        }}
      >
        <div
          className={`absolute ${loading && "hidden"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-header" : "z-z-index-dropdown"} shadow-box-shadow-top 
              bottom-bottom-base w-full rounded-none
          `}
        >
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration.lengthCheckZero && (
              <>
                <div
                  className={`${
                    showInnerSearchBar &&
                    "opacity-light-opacity bg-PopUp-BackDrop pointer-events-none h-full"
                  }`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    dropdownOptions={dropdownOptions}
                    pageSize={pageSize}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </>
            )}
        </div>

        {isLabelPopupOpen && (
          <div
            onClick={() => {
              setIsLabelPopupOpen(false);
            }}
            className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
          >
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={[
                ...new Map(
                  accumulatedData?.map((item) => [item["id"], item]),
                ).values(),
              ].filter((account) => LabelAccounts.includes(account?.id))}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}
        <div
          className={`Label_top_line_of_div w-full hidden `}
          style={{
            zIndex: "var(--z-index-overlay)",
          }}
        >
          <div>
            <p className="w-width-full font-open-sans text-font-xs text-text-primary">
              Only active (pending & approved) accounts are enabled for
              selection.
            </p>
          </div>
        </div>

        <div
          className={` relative ${type === "ReimbursementAcc" || type === "activeInactive" ? "hidden" : "block"} z-z-index-overlay bg-primary-nav `}
        >
          <div>
            <div
              className={`  hidden Qmd:block h-navbar-breadcrumb-height w-full `}
            ></div>
          </div>
        </div>

        <div
          className={`bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act w-full relative `}
        >
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={false}
            handleBack={
              type === "ReimbursementAcc" || type === "activeInactive"
                ? undefined
                : () => {
                    navigate(-1);
                  }
            }
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setIsLabelPopupOpen(true);
                      }
                    },
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled:
                      isLabelClicked && LabelAccounts?.length ? false : true,
                    hoverOption:
                      isLabelClicked && LabelAccounts?.length
                        ? " white"
                        : "black",
                    inActiveVariantNeeded: true,
                  }
                : undefined
            }
            BottomSubText={
              isLabelClicked
                ? "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts."
                : undefined
            }
            BottomSubTextVaraint="primary"
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggle,
                    title: toggle ? "Grid View" : "List View",
                    isDisabled: showSearchBar,
                    handleClick: () => handleToggle(!toggle),
                  }
                : undefined
            }
            selectionText={`Accounts selected - ${LabelAccounts?.length || "0"}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: "Select all",
                    btnType: "button",
                    enabledBgColor:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                    handleFunction: () => {
                      handleSelectAll();
                    },
                    inActiveVariantNeeded: true,

                    enabledTextColor: "var(--text-primary)",
                    isDisabled: isLabelClicked ? false : true,
                    hoverOption:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? ""
                        : "white",

                    icon:
                      filteredData.filter(
                        (item) => item?.approval_status !== "archived",
                      )?.length === LabelAccounts?.length &&
                      !!LabelAccounts?.length
                        ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                        : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            assignLabelProps={
              !isLabelClicked
                ? {
                    handleFunction: () => {
                      if (
                        flow === "create" ||
                        type === "ReimbursementAcc" ||
                        type === "activeInactive"
                      ) {
                        actionRestricted();
                        return;
                      }
                      if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        if (showSearchBar) {
                          return;
                        }
                        setisLabelClicked((prev) => {
                          if (prev) {
                            setLabelAccounts([]);
                          }
                          return !prev;
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },
                    isDisabled:
                      showSearchBar ||
                      flow === "create" ||
                      type === "ReimbursementAcc" ||
                      type === "activeInactive",
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,

                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Labels will be used to generate statistics for the associated accounts",
                  }
                : undefined
            }
            filteredSearchProps={{
              isSortDisabled: loading,
              isFilterDisabled: loading,
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search reimbursement account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setSearchUserText(val);
                    handleSubmit("search", val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Account number",
                  short_name: "Reimb A/c",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactiveBank
                      : popupType === "associated"
                        ? remAccount
                        : remAccount !== "" &&
                            type === "ReimbursementAcc" &&
                            flow !== "create"
                          ? remAccount
                          : accountNumber,
                  setValue: (val) => {
                    setAccountNumber(val);
                    handleSubmit("accountNo", val);
                  },
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remAccount !== "" && type === "ReimbursementAcc"
                        ? true
                        : false,
                  valueType: "string",
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactiveIfsc
                      : popupType === "associated"
                        ? remIFSC
                        : remIFSC !== "" &&
                            type === "ReimbursementAcc" &&
                            flow !== "create"
                          ? remIFSC
                          : isIfsc.toUpperCase(),
                  setValue: (val) => {
                    setIsIfsc(val);
                    handleSubmit("ifsc", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remIFSC !== "" && type === "ReimbursementAcc"
                        ? true
                        : false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? activeInactivePan
                      : popupType === "associated"
                        ? remPan
                        : remPan !== "" &&
                            type === "ReimbursementAcc" &&
                            flow !== "create"
                          ? remPan
                          : panNumber.toUpperCase(),
                  setValue: (val) => {
                    setPanNumber(val);
                    handleSubmit("pan", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : remPan !== "" && type === "ReimbursementAcc"
                        ? true
                        : false,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    setCurrentCategory(val);
                    handleSubmit("category", val);
                  },
                  isDropdown: true,
                  isDisabled: loading ? true : false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    setLabelSearchText(val);
                    handleSubmit(
                      "label",
                      Array.isArray(val) ? val.join(",") : val,
                    );
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: type === "activeInactive" ? true : false,
                  options: [
                    "approved",
                    "pending",
                    "rejected",
                    "blocked",
                    "archived",
                  ],
                  statusPop: true,
                  handleChange: (e) => {
                    setCurrentStatus(e);
                    setAnimateViewAll(false);
                    handleSubmit("status", e);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleDateChange(date);
                    setAnimateViewAll(false);
                  },
                },
              ],
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== ""
              ),
              isSearchClearAllDisabled:
                type === "activeInactive"
                  ? true
                  : !(
                      accountNumber?.length ||
                      isIfsc?.length ||
                      panNumber?.length ||
                      currentCategory?.length ||
                      LabelSearchText?.length ||
                      searchUserText?.length ||
                      loading
                    ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loading,
              setLoading: setLoadingData,
              isShowFilter: true,
              loadingData: loadingData,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>

        {!toggle ? (
          <div
            tabIndex="0"
            className={`scroll-p-top_md relative ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            }  ${
              type === "ReimbursementAcc" || type === "activeInactive"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-0"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0"
            } ${loading || showInnerSearchBar ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"}`}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {showInnerSearchBar && (
              <>
                <div className="absolute top-top-base left-left-base h-full w-full-width bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header overflow-hidden"></div>
              </>
            )}
            {loading ? (
              <div className="loader-container flex justify-center items-center h-full w-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <div
                ref={scrollContainerRef}
                className={`scroll scroll-py-top_sm flex flex-col min-h-0 items-center h-full-height overflow-y-auto ${showInnerSearchBar && "overflow-y-hidden pointer-events-none"} w-full`}
                style={{
                  scrollPaddingTop: "var(--padding-md)",
                  scrollPaddingBottom: "var(--padding-md)",
                }}
              >
                <div
                  className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md `}
                >
                  {accumulatedData?.map((account, index) => {
                    return (
                      <CardContainer
                        hoverHeight={
                          GlobalConfiguration?.reimbursementAccountCardHoverHeight
                        }
                        filterRef={scrollContainerRef}
                        context={account}
                        minHeight={GlobalConfiguration.BeneAccCardMinHeight}
                        isSelected={
                          Array.isArray(LabelAccounts) &&
                          LabelAccounts.includes(account.id)
                            ? true
                            : false
                        }
                        isDisabled={
                          id === account?.id
                            ? true
                            : flow === "create"
                              ? ["blocked", "archived", "rejected"].includes(
                                  account?.approval_status,
                                )
                              : isLabelClicked &&
                                account?.approval_status === "archived"
                        }
                        onClickHandler={(e, data) => {
                          if (classifiedFlow) {
                            navigate(
                              `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${account.id}`,
                              {
                                replace: true,
                              },
                            );
                            return;
                          }
                          if (type === "activeInactive") {
                            setIsalertPopup(true);
                            setFlowSelectedId(account?.id);
                            return;
                          }
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (mainType === "create") {
                              actionRestricted();
                              return;
                            }
                            if (popupType === "associated")
                              setOpenBeneAssociate(false);
                            if (flow === "create") {
                              handleDataPopup(data);
                              setModalOpen(false);
                            } else {
                              if (!isLabelClicked) {
                                navigate(
                                  `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${account.id}`,
                                  {
                                    replace: openBeneAssociate ? true : false,
                                    state: {
                                      isViewAll:
                                        location.pathname.includes("view_all"),
                                    },
                                  },
                                );
                                if (openBeneAssociate) {
                                  setOpenBeneAssociate(false);
                                }
                                if (type === "ReimbursementAcc") {
                                  setOpenBeneAssociate(false);
                                }
                              } else {
                                if (LabelAccounts?.includes(account.id)) {
                                  setLabelAccounts(
                                    LabelAccounts.filter(
                                      (id) => id !== account.id,
                                    ),
                                  );
                                } else {
                                  setLabelAccounts([
                                    ...LabelAccounts,
                                    account.id,
                                  ]);
                                  setLabeldata([...Labeldata, account]);
                                }
                              }
                            }
                          }
                        }}
                      >
                        <card-body>
                          <TextWithIcon
                            type={"text"}
                            text={account.name
                              .toLowerCase()
                              .split(" ")
                              .map(
                                (word) =>
                                  word
                                    .charAt(
                                      GlobalConfiguration?.lengthCheckZero,
                                    )
                                    .toUpperCase() +
                                  word.slice(
                                    GlobalConfiguration?.lengthCheckOne,
                                  ),
                              )
                              .join(" ")}
                            textColor={"var(--text-primary)"}
                            subText={"Account name"}
                            iconComponentArray={[
                              ...(!isLabelClicked
                                ? [
                                    {
                                      icon: ICONS.REIMBURSEMENT_ACCOUNT_WITH_WHITE_CIRCLE,
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                              ...(isLabelClicked
                                ? [
                                    {
                                      icon:
                                        Array.isArray(LabelAccounts) &&
                                        LabelAccounts.includes(account.id)
                                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                          : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                            ]}
                          />

                          <div className="flex gap-x-gap-sm justify-between items-center">
                            <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                              <p
                                className={`text-font-sm text-text-primary flex-1 truncate font-normal pl-padding-sm`}
                              >
                                <TickerAnimation
                                  text={formatAccountNumber(
                                    account.bank_acc_no,
                                  )}
                                />
                              </p>
                              <div className="w-full relative flex pl-padding-sm justify-between items-center ">
                                <p
                                  className={`text-font-xs text-text-secondary flex-1 truncate font-normal transform-none`}
                                >
                                  Account number
                                </p>
                              </div>
                            </div>
                            <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                              <div className="w-banklogo-width-sm h-icon-xs flex-shrink-0">
                                <IfscCodeMapper ifscCode={account?.ifsc_code} />
                              </div>
                            </div>
                          </div>
                        </card-body>
                        <card-hover>
                          <TextWithIcon
                            text={account?.approval_status}
                            subText={"Account status"}
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={getStatusColor(account?.approval_status)}
                          />
                          <TextWithIcon
                            text={
                              account?.labels?.join(", ") ||
                              "No labels assigned"
                            }
                            iconComponentArray={[
                              {
                                icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                              },
                            ]}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                          />
                        </card-hover>
                      </CardContainer>
                    );
                  })}
                </div>
              </div>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full ">
                <img
                  src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive associated accounts found."
                      : "No data found."}
                </p>

                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided Bank under the reimbursement account classification."
                        : "There are no existing inactive accounts linked to the provided Bank under the reimbursement account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided PAN under the reimbursement account classification."
                        : "There are no existing inactive accounts linked to the provided PAN under the reimbursement account classification."}
                    </p>
                  )
                ) : (
                  (currentCategory !== "" ||
                    panNumber !== "" ||
                    accountNumber !== "" ||
                    isIfsc !== "" ||
                    searchUserText !== "" ||
                    isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            className={`h-height-full ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity" : ""} ${
              type === "ReimbursementAcc" || type === "activeInactive"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-height-base"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-height-base"
            } ${loading || showInnerSearchBar ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"} `}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.keyCode === "83" ||
                event.keyCode === "87" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.stopPropagation();
                event.preventDefault();

                return false;
              }
              event.stopPropagation();
            }}
          >
            {loading ? (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <>
                <div
                  className={`${toggle && animateViewAll && currentPage === GlobalConfiguration?.lengthCheckOne ? "animate-slide-next" : ""} scroll flex flex-col items-center z-z-index-content relative w-full flex-1 h-height-full overflow-y-auto`}
                  ref={filterRef}
                  style={{
                    scrollPaddingTop: "var(--padding-md)",
                    scrollPaddingBottom: "var(--padding-md)",
                  }}
                >
                  <div className="standard-list-view-alignment">
                    {accumulatedData?.map((item) => {
                      return (
                        <ListContainer
                          hoverHeight={
                            GlobalConfiguration?.reimbursementAccountListHoverHeight
                          }
                          key={item.id}
                          filterRef={filterRef}
                          onClickHandler={(e, data) => {
                            if (classifiedFlow) {
                              navigate(
                                `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${item.id}`,
                                {
                                  replace: true,
                                },
                              );
                              return;
                            }
                            if (type === "activeInactive") {
                              setIsalertPopup(true);
                              setFlowSelectedId(item?.id);
                              return;
                            }
                            if (showInnerSearchBar) {
                              return;
                            } else {
                              if (mainType === "create") {
                                actionRestricted();
                                return;
                              }
                              if (popupType === "associated")
                                setOpenBeneAssociate(false);
                              if (flow === "create") {
                                handleDataPopup(data);
                                setModalOpen(false);
                              } else {
                                if (!isLabelClicked) {
                                  navigate(
                                    `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${item.id}`,
                                    {
                                      state: {
                                        isViewAll:
                                          location.pathname.includes(
                                            "view_all",
                                          ),
                                      },
                                    },
                                  );
                                  if (type === "ReimbursementAcc") {
                                    setOpenBeneAssociate(false);
                                  }
                                } else {
                                  if (LabelAccounts?.includes(item.id)) {
                                    setLabelAccounts(
                                      LabelAccounts.filter(
                                        (id) => id !== item.id,
                                      ),
                                    );
                                  } else {
                                    setLabelAccounts([
                                      ...LabelAccounts,
                                      item.id,
                                    ]);
                                    setLabeldata([...Labeldata, item]);
                                  }
                                }
                              }
                            }
                          }}
                          isSelected={
                            Array.isArray(LabelAccounts) &&
                            LabelAccounts.includes(item.id)
                          }
                          isDisabled={
                            id === item?.id
                              ? true
                              : flow === "create"
                                ? ["blocked", "archived", "rejected"].includes(
                                    item?.approval_status,
                                  )
                                : isLabelClicked &&
                                  item?.approval_status === "archived"
                          }
                          context={item}
                        >
                          <list-body>
                            <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                              <div
                                className={`flex flex-col gap-y-gap-sm w-full`}
                              >
                                <div className="w-full flex gap-x-gap-sm">
                                  <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                                    <CommonBankLogo
                                      variant="small"
                                      ifsc={item.ifsc_code}
                                    />
                                  </div>
                                  <p className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                                    <TickerAnimation
                                      text={standardAccountNumberFormat(
                                        item?.bank_acc_no,
                                        true,
                                      )}
                                    />
                                  </p>
                                  <div className="border-l border-primary-bg"></div>
                                  <div className="flex gap-x-gap-sm justify-end items-center">
                                    <p
                                      style={{
                                        color: getStatusColor(
                                          item?.approval_status,
                                        ),
                                      }}
                                      className={` text-font-xs font-semibol capitalize min-w-standard-approval-status-min-width text-right`}
                                    >
                                      {item?.approval_status}
                                    </p>

                                    <img
                                      style={{
                                        display: isLabelClicked
                                          ? "flex"
                                          : "none",
                                      }}
                                      className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                                      src={
                                        Array.isArray(LabelAccounts) &&
                                        LabelAccounts.includes(item.id)
                                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                          : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                                      }
                                      alt=""
                                    />
                                  </div>
                                </div>
                                <div className="w-full pl-padding-sm  flex justify-between items-center relative">
                                  <p
                                    className={`text-font-xs text-text-primary flex-1 truncate font-normal`}
                                  >
                                    <TickerAnimation
                                      text={accountNameStandardised(item?.name)}
                                    />
                                  </p>
                                  <div className="gap-x-gap-sm flex ml-margin-sm justify-end">
                                    <img
                                      className="w-icon-sm h-icon-sm flex-shrink-0"
                                      src={
                                        ICONS.REIMBURSEMENT_ACCOUNT_WITH_WHITE_CIRCLE
                                      }
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </list-body>
                          <list-hover>
                            <ListTextWithIcon
                              type={"text"}
                              text={
                                item?.labels?.join(", ") ||
                                "No labels assigned "
                              }
                              iconComponentArray={[
                                {
                                  icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                                },
                              ]}
                            />
                          </list-hover>
                        </ListContainer>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive associated accounts found."
                      : "No data found."}
                </p>
                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided Bank under the reimbursement account classification."
                        : "There are no existing inactive accounts linked to the provided Bank under the reimbursement account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active accounts linked to the provided PAN under the reimbursement account classification."
                        : "There are no existing inactive accounts linked to the provided PAN under the reimbursement account classification."}
                    </p>
                  )
                ) : (
                  (currentCategory !== "" ||
                    panNumber !== "" ||
                    accountNumber !== "" ||
                    isIfsc !== "" ||
                    searchUserText !== "" ||
                    isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        )}

        {isLabelClicked && (
          <div className="flex-shrink-0 Qmd:hidden block"></div>
        )}
      </div>
    </>
  );
};

export default ReimbursementAccountViewAll;
